class ReadMoreText {
  constructor(el) {
    this.$el = el;
    this.cN = 'read-more-text';
    if (!this.$el.classList.contains(`${this.cN}--bound`)) {
      this.$el.classList.add(`${this.cN}--bound`);

      this.$readMoreButton = this.$el.querySelector(`.${this.cN}__button`);

      this.open = this.$el.classList.contains(`${this.cN}--open`);
      this.rlt = (this.$el.dataset && this.$el.dataset.rlt) || 'Weniger lesen';
      this.rmt = (this.$el.dataset && this.$el.dataset.rmt) || 'Mehr lesen';

      this.InitEvents();
    }
  }

  InitEvents() {
    const self = this;
    if (this.$readMoreButton) {
      this.$readMoreButton.addEventListener('click', (e) => {
        e.preventDefault();
        self.ToggleOpenState();
      });
    }
  }

  ToggleOpenState() {
    this.$el.classList.toggle(`${this.cN}--open`);
    this.open = this.$el.classList.contains(`${this.cN}--open`);
    this.$readMoreButton.textContent = !this.open ? this.rmt : this.rlt;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.read-more-text:not(.read-more-text--bound)').forEach(
    el => new ReadMoreText(el),
  );
});
